import { URI } from "../../../base/common/uri";
import { IAnyWorkspaceIdentifier } from "../../workspace/common/workspace";
import { Event } from "../../../base/common/events";
import { createDecorator } from "../../instantiation/common/registry";
import { Disposable } from "../../../base/common/lifecycle";

export const enum ProfileResourceType {
    Settings = 'settings',
    Keybindings = 'keybindings',
    Snippets = 'snippets',
    Prompts = 'prompts',
    Tasks = 'tasks',
    Extensions = 'extensions',
    GlobalState = 'globalState',
    Mcp = 'mcp',
}

/**
 * Flags to indicate whether to use the default profile or not.
 */
export type UseDefaultProfileFlags = { [key in ProfileResourceType]?: boolean };
export type ProfileResourceTypeFlags = UseDefaultProfileFlags;


export interface IUserDataProfile {
    readonly id: string;
    readonly isDefault: boolean;
    readonly name: string;
    // readonly icon?: string;
    // readonly location: URI;
    // readonly globalStorageHome: URI;
    // readonly settingsResource: URI;
    // readonly keybindingsResource: URI;
    // readonly tasksResource: URI;
    // readonly snippetsHome: URI;
    // readonly promptsHome: URI;
    // readonly extensionsResource: URI;
    // readonly mcpResource: URI;
    // readonly cacheHome: URI;
    // readonly useDefaultFlags?: UseDefaultProfileFlags;
    // readonly isTransient?: boolean;
    // readonly workspaces?: readonly URI[];
}

export function isUserDataProfile(thing: unknown): thing is IUserDataProfile {
    const candidate = thing as IUserDataProfile | undefined;

    return !!(candidate && typeof candidate === 'object'
        && typeof candidate.id === 'string'
        && typeof candidate.isDefault === 'boolean'
        && typeof candidate.name === 'string'
        // && URI.isUri(candidate.location)
        // && URI.isUri(candidate.globalStorageHome)
        // && URI.isUri(candidate.settingsResource)
        // && URI.isUri(candidate.keybindingsResource)
        // && URI.isUri(candidate.tasksResource)
        // && URI.isUri(candidate.snippetsHome)
        // && URI.isUri(candidate.promptsHome)
        // && URI.isUri(candidate.extensionsResource)
        // && URI.isUri(candidate.mcpResource)
    );
}


export const IUserDataProfilesService = createDecorator<IUserDataProfilesService>('IUserDataProfilesService');

export interface IUserDataProfilesService {
    readonly _serviceBrand: undefined;

    readonly profilesHome: URI;
    readonly defaultProfile: IUserDataProfile;

    // readonly onDidChangeProfiles: Event<DidChangeProfilesEvent>;
    readonly profiles: readonly IUserDataProfile[];

    readonly onDidResetWorkspaces: Event<void>;

    // createNamedProfile(name: string, options?: IUserDataProfileOptions, workspaceIdentifier?: IAnyWorkspaceIdentifier): Promise<IUserDataProfile>;
    // createTransientProfile(workspaceIdentifier?: IAnyWorkspaceIdentifier): Promise<IUserDataProfile>;
    // createProfile(id: string, name: string, options?: IUserDataProfileOptions, workspaceIdentifier?: IAnyWorkspaceIdentifier): Promise<IUserDataProfile>;
    // updateProfile(profile: IUserDataProfile, options?: IUserDataProfileUpdateOptions,): Promise<IUserDataProfile>;
    // removeProfile(profile: IUserDataProfile): Promise<void>;

    // setProfileForWorkspace(workspaceIdentifier: IAnyWorkspaceIdentifier, profile: IUserDataProfile): Promise<void>;
    // resetWorkspaces(): Promise<void>;

    // cleanUp(): Promise<void>;
    // cleanUpTransientProfiles(): Promise<void>;
}




export class UserDataProfilesService extends Disposable implements IUserDataProfilesService {
    _serviceBrand: undefined;
    
    profilesHome: URI;
    defaultProfile: IUserDataProfile;
    profiles: readonly IUserDataProfile[];
    onDidResetWorkspaces: Event<void>;
}